"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const ChargeTabIconFilled = (props) => {
    const { width, height, color } = props;
    return (react_1.default.createElement(react_native_svg_1.Svg, { width: width, height: height, viewBox: "0 0 13.865 22.71" },
        react_1.default.createElement(react_native_svg_1.G, { id: "illustarations-and-Icons", stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" },
            react_1.default.createElement(react_native_svg_1.G, { id: "Icons", transform: "translate(-1170.000000, -596.000000)" },
                react_1.default.createElement(react_native_svg_1.G, { id: "atom-/-icon-/-filled-/-custom-/-charge", transform: "translate(1164.000000, 594.000000)" },
                    react_1.default.createElement(react_native_svg_1.Path, { d: "M6.06661725,12.7534932 L6.03018448,12.8316345 C5.91401964,13.1481738 6.14635913,13.5015626 6.50073882,13.5015626 L10.9377388,13.5015626 L10.0041635,21.443142 C9.93929337,21.9945383 10.6871256,22.2250998 10.9440026,21.7329004 L16.945812,10.2329004 L16.978661,10.155128 C17.0815968,9.84107227 16.8491577,9.50156263 16.5025482,9.50156263 L12.0707388,9.50156263 L12.9963528,2.56764449 C13.0688874,2.02363484 12.3389102,1.77698049 12.0666173,2.25349316 L6.06661725,12.7534932 Z", id: "Path-13", fill: color }))))));
};
ChargeTabIconFilled.defaultProps = {
    color: 'currentColor',
    width: 20,
    height: 20,
};
exports.default = react_1.default.memo(ChargeTabIconFilled);
